import { LegInformationDeatils, StationDetails, Vendor } from '@app/trips/schedule-creation/model/schedule-model';
import * as moment from 'moment';
import { CharterEstimateStatusList, EstimateStatusList } from '../constants/estimate-constants';
export class Estimates {
    public badgeShow: boolean = false;
    public vendorLogin: boolean = false;
    public operatorLogin: boolean = false;
    public show: boolean = false;
    public allowToScrollData: boolean = true;
    public statusList = EstimateStatusList;
    public typeOfList: string = "All";
    public loadStatus: string = "";
    public filterStatus: string = "";
    public searchItemEv: any;
    public roleID: any;
    public charterEstimateStatusList = CharterEstimateStatusList;
    public chipEnabled: boolean = true;
    public statusListDisabled: boolean = false;
}
export const RefreshByStatusList = [
    { type: 'All', refreshBy: 'Drafts' },
    { type: 'Trip Estimate', refreshBy: 'Estimated' },
    { type: 'Activated', refreshBy: 'ActiveEstimate'},
    { type: 'Expired', refreshBy: 'ExpiredEstimated'},
    { type: 'Accepted', refreshBy: 'Confirmed' },
    { type: 'Pending', refreshBy: 'Processing' },
    { type: 'Declined', refreshBy: 'Declined' },
  ];
export interface Leg {
    name: string;
    id: string;
    Status: string;
    dateTime: Date;
    current: boolean;
}

export interface GetQuoteAll {
    SRID: string | number;
    DT_RowId: string | number;
    ClientName: string;
    From: string;
    To: string;
    AircraftType: string;
    depart: Date;
    sectortotimezone: string;
    sectorfromtimezone: string;
    sectorseltimezone: string;
    createdDate: Date;
    Legs: Leg[];
    Station: string;
    ActiveTripID?: any;
    Status: string;
    TripStatus: string;
    CharterUserID: string | number;
    CharterUserName: string;
    CharterString: string;
    OperatorAccepted: string | number;
    CharterAccepted: string | number;
    CharterStatus: string;
    infinityScroll: boolean;
    aircraftExtImage:any;
    aircraftInteriorImages: any;
}

export interface GetQuoteAllResponse {
    ResponseCode: string;
    APIName: string;
    GetQuoteAll: GetQuoteAll[];
    ResponseStatus: string;
}


export interface ServiceProvider {
    sector: string;
    firebaseuid: string;
    vendorid: string;
    Totalprice: number;
    logo: string;
    VendorName: string;
    type: string;
    station: string;
    legid: number;
    name: string;
    price: number;
    vendorId: string;
    serviceName: string;
    legId: number;
    UID: string;
    registertype: string;
    chargeId: string;
    sharray: string;
    countryList: string;
    autoselect?: string
}

export interface GetTCEDataByDraftID {
    BLKTIME: string;
    DIST: string;
    ETDGMT: string;
    ETAGMT: string;
    ETALT: string;
    ETDLT: string;
    departDate: Date;
    depart: Date;
    aircraft: string;
    timezone: string;
    sector: string;
    stoptype: string;
    GMTPLUSORIGIN: string;
    GMTPLUSDEST: string;
    TIMEZONE: string;
    routeID: string;
    noOfCrew: string;
    noOfPax: string;
    flightPlanresponseID: string;
    fuelPolicy: string;
    adequate: string;
    alt1: string;
    alt2: string;
    depAlt: string;
    etops: string;
    flightLvelalt1?: any;
    flightLvelalt2?: any;
    cruiseSpeed: string;
    maxflightlevelUnit: string;
    flightLevelType: string;
    extrafuel: string;
    fuelUnit: string;
    travelDistrance: string;
    timeZone: string;
    CreatedDate: string;
    sectorfromtimezone: string;
    sectortotimezone: string;
    Sector: string;
    sectorseltimezone: string;
    savedlegid: string;
    from: string;
    to: string;
    legid: string;
    id: string;
    fromICAO: string;
    toICAO: string;
    LegType: string;
    removed: boolean;
    Arrivaltime: Date;
    flyingSeconds: number;
    Legstage: string;
    FlightRule: string;
    FlightType: string;
    Operation: string;
    legId: number;
    serviceProvider: ServiceProvider[];
}
export interface GetTCEDataByDraftIDResponse {
    ResponseCode: string;
    APIName: string;
    GetTCEDataByDraftID: GetTCEDataByDraftID[];
    ResponseStatus: string;
}
export class ServiceVendorModel {
    public name: string;
    public logo: string;
    public price: number;
    public vendorId: any;
    public UID: string;
    public sector: string;
    public station: string;
    public chargeId: number;
    public serviceName: string;
    public backendFormat: any;
    public legId: number;
    public autoselect: any;
    public clickable: any;
    public rating?:number;
    public stationType?: string;
    constructor({
        name,
        logo,
        price,
        vendorId,
        UID,
        sector,
        station,
        chargeId,
        serviceName,
        backendFormat,
        legId,
        autoselect,
        clickable,
        rating,
        stationType,
    }) {
        this.name = name;
        this.logo = logo;
        this.price = Number(price);
        this.vendorId = vendorId;
        this.UID = UID;
        this.sector = sector;
        this.station = station;
        this.chargeId = chargeId;
        this.serviceName = serviceName;
        this.backendFormat = backendFormat;
        this.legId = legId;
        this.autoselect = autoselect;
        this.clickable =
            !clickable || (autoselect == "true" && autoselect != undefined)
                ? true
                : false;
        this.rating = rating;
        this.stationType = stationType;
    }
}
export interface GetTripEstimateDetailsResponse {
    ResponseCode: string;
    APIName: string;
    GetTripEstimateDetails: string;
    ResponseStatus: string;
}
export interface DownloadCharterEstimateOnTripid {
    ResponseCode: string;
    APIName: string;
    DownloadCharterIternaryPDF: string;
    ResponseStatus: string;
}
export interface Deserializable {
    deserialize(input: any): this;
}
export class BackendFormatSavedraft implements Deserializable {
    public fromStation: StationDetails;
    public toStation: StationDetails;
    public departDate: string;
    public timeType: string;
    public noOfCrew: number;
    public noOfPax: number;
    public flightType: string;
    public operationType: string;
    public stopType: string; // check
    public flightRule: string;
    public fuelPolicy: string = "MaximumFuelPolicy";
    public adequate: string = "Auto";
    public alt1: string;
    public alt2: string;
    public depAlt: string;
    public fuelonBoard: number;
    public etops: string;
    public flightLvelalt1: number;
    public flightLvelalt2: number;
    public cruiseSpeed: string;
    public aircraftId: string  | number;
    public maxflightlevelUnit: string;
    public serviceProvider = [];
    public BLKTIME: string;
    public legRouteid: string;
    public flightPlanresponseID: string;
    public overflyingCountry = [];
    public travelDistrance: number;
    public ETDGMT: string;
    public ETAGMT: string;
    public ETALT: string;
    public ETDLT: string;
    public vendorSelectionCompleted: boolean;
    public legId: number;
    public sector: string;
    public flightLevelType: string = "OptimumFlightLevelDefinition";
    public flightLvel: number;
    public extrafuel: number;
    public fuelUnit: string = "Pound";
    public legAffected: boolean;
    public legEditable: boolean;
    public newLeg: boolean;
    public legOnHighlight: boolean;
    public legTotalCost: number;
    public baseStationEditable: boolean;
    public GMTPLUSORIGIN: string;
    public GMTPLUSDEST: string;
    public sharray = [];
    public removed: boolean = false;
    public etopsEnable: string;
    public etopsMinutes: number;
    constructor(LegInfo: LegInformationDeatils) {
        this.fromStation = LegInfo.fromStation;
        this.toStation = LegInfo.toStation;
        this.departDate = this.covertUTCtime(
            LegInfo.fromStation.timeZone,
            LegInfo.departDate,
        );
        this.timeType = LegInfo.timeType;
        this.noOfCrew = LegInfo.noOfCrew;
        this.noOfPax = LegInfo.noOfPax;
        this.flightType = LegInfo.flightType;
        this.operationType = LegInfo.operationType;
        this.stopType = LegInfo.stopType;
        this.flightRule = LegInfo.flightRule;
        this.fuelPolicy = LegInfo.fuelPolicy;
        this.adequate = LegInfo.adequate;
        this.alt1 = LegInfo.alt1;
        this.alt2 = LegInfo.alt2;
        this.depAlt = LegInfo.depAlt;
        this.fuelonBoard = LegInfo.fuelonBoard;
        this.etops = LegInfo.etops;
        this.flightLvelalt1 = LegInfo.flightLvelalt1;
        this.flightLvelalt2 = LegInfo.flightLvelalt2;
        this.cruiseSpeed = LegInfo.cruiseSpeed;
        this.GMTPLUSORIGIN = LegInfo.GMTPLUSORIGIN;
        this.GMTPLUSDEST = LegInfo.GMTPLUSDEST;
        this.aircraftId = typeof LegInfo.aircraftId == 'number' ? String(LegInfo.aircraftId) : LegInfo.aircraftId;
        this.maxflightlevelUnit = LegInfo.maxflightlevelUnit;
        LegInfo.serviceProvider.forEach((element: Vendor) => {
            if (element.backendFormat) {
                element.backendFormat.logo = "";
            }
            this.serviceProvider.push({
                name: element.name,
                logo: "",
                price:element.Totalprice != undefined ?element.Totalprice: element.price,
                vendorId: element.vendorId,
                UID: element.UID,
                sector: element.sector,
                station: element.station,
                chargeId: element.chargeId,
                serviceName: element.serviceName,
                legId: LegInfo.legId,
                backendFormat: element.backendFormat,
                sharray: element.sharray,
                carbonoffsetstatus: element.carbonoffsetstatus,
                actionItems: element.actionItems,
                usdPrice:element?.Totalprice
            });
        });
        this.BLKTIME = LegInfo.BLKTIME;
        this.legRouteid = LegInfo.legRouteid;
        this.flightPlanresponseID = LegInfo.flightPlanresponseID;
        this.overflyingCountry = LegInfo.overflyingCountry;
        this.travelDistrance = LegInfo.travelDistrance;
        this.ETDGMT = LegInfo.ETDGMT;
        this.ETAGMT = LegInfo.ETAGMT;
        this.ETALT = LegInfo.ETALT;
        this.ETDLT = LegInfo.ETDLT;
        this.vendorSelectionCompleted = LegInfo.vendorSelectionCompleted;
        this.legId =
            LegInfo.backendLegId != 0
                ? LegInfo.backendLegId
                : LegInfo.srid
                    ? LegInfo.backendLegId
                    : LegInfo.legId
                        ? LegInfo.legId
                        : LegInfo.serviceProvider[0].legId;
        this.sector =
            this.fromStation.name.substr(0, 4) +
            "-" +
            this.toStation.name.substr(0, 4);
        if (LegInfo.flightLevelType && LegInfo.flightLevelType != "") {
            this.flightLevelType = LegInfo.flightLevelType;
        }
        this.flightLvel = LegInfo.flightLvel;
        this.extrafuel = LegInfo.extrafuel;
        this.fuelUnit = LegInfo.fuelUnit;

        this.legAffected = LegInfo.legAffected;
        this.legEditable = LegInfo.legEditable;
        this.newLeg = LegInfo.modifiedLeg;
        this.legOnHighlight = LegInfo.legOnHighlight;
        this.baseStationEditable = LegInfo.baseStationEditable;
        this.etopsEnable = LegInfo.advancedEtops;
        this.etopsMinutes = LegInfo.advancedEtops == 'Yes' ? LegInfo.advancedEtopsMin : null;
    }
    public covertUTCtime(timeZone, time) {
        return moment.tz(time, timeZone).utc().format();
    }

    public deserialize(input: any): this {
        Object.assign(this, input);
        this.fromStation = new StationDetails(
            input.fromStation.name,
            input.fromStation.timeZone,
        ).deserialize(input.fromStation);
        this.toStation = new StationDetails(
            input.toStation.name,
            input.toStation.timeZone,
        ).deserialize(input.toStation);
        return this;
    }

}
export class BackendActivateTripLeglistFormat implements Deserializable {
    public fromStation: StationDetails;
    public toStation: StationDetails;
    public departDate: string;
    public timeType: string;
    public noOfCrew: number;
    public noOfPax: number;
    public flightType: string;
    public operationType: string;
    public stopType: string; // check
    public flightRule: string;
    public fuelPolicy: string;
    public adequate: string;
    public alt1: string;
    public alt2: string;
    public depAlt: string;
    public fuelonBoard: number;
    public etops: string;
    public flightLvelalt1: number;
    public flightLvelalt2: number;
    public cruiseSpeed: string;
    public aircraftId: string | number;
    public maxflightlevelUnit: string;
    public serviceProvider = [];
    public BLKTIME: string;
    public legRouteid: string;
    public flightPlanresponseID: string;
    public overflyingCountry = [];
    public travelDistrance: number;
    public ETDGMT: string;
    public ETAGMT: string;
    public ETALT: string;
    public ETDLT: string;
    public legId: number;
    public sector: string;
    public flightLevelType: string;
    public flightLvel: number;
    public extrafuel: number;
    public fuelUnit: string;
    public GMTPLUSORIGIN: string;
    public GMTPLUSDEST: string;
    public etopsEnable: string;
    public etopsMinutes: number;
    public estimateDraftId: any;
    constructor(LegInfo: LegInformationDeatils) {
        this.fromStation = LegInfo.fromStation;
        this.toStation = LegInfo.toStation;
        // if (LegInfo.timeType == "true") {
        this.departDate = this.covertUTCtime(
            LegInfo.fromStation.timeZone,
            LegInfo.departDate,
        );
        // }
        // else {
        //     let departDate;
        //     if (LegInfo.departDate.includes('+')) {
        //         departDate = LegInfo.departDate.slice(0, -6) + 'Z'
        //     }
        //     else {
        //         departDate = LegInfo.departDate;
        //     }
        //     this.departDate = departDate;
        // }
        this.timeType = LegInfo.timeType;
        this.noOfCrew = LegInfo.noOfCrew;
        this.noOfPax = LegInfo.noOfPax;
        this.flightType = LegInfo.flightType;
        this.operationType = LegInfo.operationType;
        this.stopType = LegInfo.stopType; // check
        this.flightRule = LegInfo.flightRule;
        this.fuelPolicy = LegInfo.fuelPolicy;
        this.adequate = LegInfo.adequate;
        this.alt1 = LegInfo.alt1;
        this.alt2 = LegInfo.alt2;
        this.depAlt = LegInfo.depAlt;
        this.fuelonBoard = LegInfo.fuelonBoard;
        this.etops = LegInfo.etops;
        this.flightLvelalt1 = LegInfo.flightLvelalt1;
        this.flightLvelalt2 = LegInfo.flightLvelalt2;
        this.cruiseSpeed = LegInfo.cruiseSpeed;
        this.aircraftId = typeof LegInfo.aircraftId == 'number' ? String(LegInfo.aircraftId) :  LegInfo.aircraftId;
        this.maxflightlevelUnit = LegInfo.maxflightlevelUnit;
        LegInfo.serviceProvider.forEach((element: Vendor) => {
            this.serviceProvider.push(Object.assign({}, element));
        });

        this.BLKTIME = LegInfo.BLKTIME;
        this.legRouteid = LegInfo.legRouteid;
        this.flightPlanresponseID = LegInfo.flightPlanresponseID;
        this.overflyingCountry = LegInfo.overflyingCountry;
        this.travelDistrance = LegInfo.travelDistrance;
        this.ETDGMT = LegInfo.ETDGMT;
        this.ETAGMT = LegInfo.ETAGMT;
        this.ETALT = LegInfo.ETALT;
        this.ETDLT = LegInfo.ETDLT;
        this.legId = LegInfo.legId;
        this.sector = LegInfo.sector;
        this.flightLevelType = LegInfo.flightLevelType;
        this.flightLvel = LegInfo.flightLvel;
        this.extrafuel = LegInfo.extrafuel;
        this.fuelUnit = LegInfo.fuelUnit;
        this.GMTPLUSORIGIN = LegInfo.GMTPLUSORIGIN;
        this.GMTPLUSDEST = LegInfo.GMTPLUSDEST;
        this.etopsEnable = LegInfo.advancedEtops;
        this.etopsMinutes = LegInfo.advancedEtops == 'Yes' ? LegInfo.advancedEtopsMin: null;
        this.serviceProvider.forEach((element: any) => {
            element.logo = "";
        });
        this.estimateDraftId = LegInfo.DraftEstimateId;
    }
    public deserialize(input: any): this {
        Object.assign(this, input);
        return this;
    }
    public covertUTCtime(timeZone, time) {
        return moment.tz(time, timeZone).utc().format();
    }
}
export class BackendActivateTripTripFormat {
    public legList = new Array<BackendActivateTripLeglistFormat>();
    public SectorServiceArray = [];
    public StationServiceArray = [];
    public TotalCost: number;
}